import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { graphql, useFragment } from 'react-relay';

import { BoxFlex, ErrorIcon, PaymentFooter } from '@woovi/ui';

import type { PaymentCheckoutDeactivated_checkout$key } from './__generated__/PaymentCheckoutDeactivated_checkout.graphql.ts';
import PaymentCheckoutCompanyData from './PaymentCheckoutCompanyData.tsx';
import PaymentCheckoutTitle from './PaymentCheckoutTitle.tsx';
import PaymentCompanySupport from '../support/PaymentCompanySupport.tsx';

import type { ReactNode } from 'react';

const PaymentCheckoutDeactivated = (props): ReactNode => {
  const { t } = useTranslation();
  const theme = useTheme();

  const checkout = useFragment<PaymentCheckoutDeactivated_checkout$key>(
    graphql`
      fragment PaymentCheckoutDeactivated_checkout on Checkout {
        company {
          nameFriendly
          projectType
          taxID {
            taxID
          }
          ...PaymentCheckoutCompanyData_company
          ...PaymentCompanySupport_company
        }
        ...PaymentCheckoutTitle_checkout
      }
    `,
    props.checkout,
  );

  return (
    <Stack spacing={2}>
      <BoxFlex sx={{ flexDirection: 'column', alignItems: 'center' }}>
        <ErrorIcon />
      </BoxFlex>
      <Typography
        variant={'h2'}
        sx={{
          fontSize: theme.typography.pxToRem(22),
          fontWeight: theme.typography.fontWeightBold,
          textAlign: 'center',
          color: theme.palette.secondary.main,
        }}
      >
        {t('Checkout deactivated')}
      </Typography>
      <PaymentCheckoutTitle checkout={checkout} />
      <PaymentCheckoutCompanyData company={checkout.company} />
      <PaymentCompanySupport company={checkout.company} />
      <PaymentFooter projectType={checkout.company?.projectType} />
    </Stack>
  );
};

export default PaymentCheckoutDeactivated;
